import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
// import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { IndexView, SimpleStriped } from 'blocks/tables';
import validationSchema from './validationSchema';
import { TextField } from '@mui/material';
import MenuItem from '@mui/material';
import FileUploadViewer from 'views/NotFoundCover/FileUploadViewer';
import YearInformation from './YearInformation';
import cloneDeep from 'lodash.clonedeep';

const ThirdStep = ({ handleCurrentStep, thirdState, sectionData, applicationNo, }) => {
  const fileName1 =
    thirdState && thirdState.photoData && thirdState.photoData.name;

  const [fileName, setFileName] = useState(fileName1 || '');

  let isDisabled = true;

  const previousSchoolInfo = {
    id: 1,
    fromYear: '',
    toYear: '',
    fromClass: '',
    toClass: '',
    city: '',
    state: '',
    country: '',
  };

  console.log('applicationNo', applicationNo);

  const [noOfYears, setNoOfYears] = React.useState([previousSchoolInfo]);

  const HandleAddSchoolInfo = () => {
    const id = noOfYears[noOfYears.length - 1].id + 1;
    const previousSchoolInfo_ = cloneDeep(previousSchoolInfo);
    previousSchoolInfo_.id = id;
    noOfYears.push(previousSchoolInfo_);
    setNoOfYears(cloneDeep(noOfYears));
  };

  const handleRemove = (id) => {
    if (noOfYears.length === 1) {
      alert('atleast one entry is required.');
    } else {
      const noOfYears_ = noOfYears.filter((x) => x.id !== id);
      setNoOfYears(cloneDeep(noOfYears_));
    }
  };

  console.log('noofy', noOfYears);

  const onSubmit = () => {
    handleCurrentStep(4, formik.values);
  };

  const formik = useFormik({
    initialValues: thirdState,
    validationSchema: validationSchema,
    onSubmit,
  });

  if (formik && formik.values && Object.keys(formik.errors).length === 0) {
    isDisabled = false;
  }

  // const handleFileChange = (event) => {
  //   formik.values.photo = event.target.value;
  //   formik.values.photoData = event.target.files[0];
  //   setFileName(formik.values.photoData.name);
  // };

  const handleUpdatePhotoBirthFileInfo = (file, fileName, imagePreviewUrl) => {
    formik.values.photoBirth = file;
    formik.values.photoBirthFileName = fileName;
    formik.values.photoBirthImagePreviewUrl = imagePreviewUrl;
  };

  const handleUpdateAadharFileInfo = (file, fileName, imagePreviewUrl) => {
    formik.values.photoAadhar = file;
    formik.values.photoAadharFileName = fileName;
    formik.values.photoAadharImagePreviewUrl = imagePreviewUrl;
  };

  const handleUpdateFatherAadharFileInfo = (
    file,
    fileName,
    imagePreviewUrl,
  ) => {
    formik.values.photoFatherAadhar = file;
    formik.values.photoFatherAadharFileName = fileName;
    formik.values.photoFatherAadharImagePreviewUrl = imagePreviewUrl;
  };

  const handleUpdateMotherAadharFileInfo = (
    file,
    fileName,
    imagePreviewUrl,
  ) => {
    formik.values.photoMotherAadhar = file;
    formik.values.photoMotherAadharFileName = fileName;
    formik.values.photoMotherAadharImagePreviewUrl = imagePreviewUrl;
  };

  return (
    <Box>
      <div>
        <br />
        <Typography variant="h4" align="center">
          Upload Documents
        </Typography>
        <br />
        <br />
        <Grid container spacing={4}>
          <Grid item xs={10} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Upload Aadhar Card/Passport of the Student*
            </Typography>

            <div id="aadhar">
              <FileUploadViewer
                key={`key-Aadhar`}
                info={'aadhar'}
                applicationNo={applicationNo}
                imageType={'photoAadhar'}
                file={formik.values && formik.values.photoAadhar}
                fileName={formik.values && formik.values.photoAadharFileName}
                imagePreviewUrl={
                  formik.values && formik.values.photoAadharImagePreviewUrl
                }
                handleUpdateFileInfo={(file, fileName, imagePreviewUrl) => {
                  console.log('hi hello');
                  handleUpdateAadharFileInfo(file, fileName, imagePreviewUrl);
                }}
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Upload Birth Certificate of the Student*
            </Typography>

            <div id="photoBirth">
              <FileUploadViewer
                key={`key-photoBirth`}
                info={'photoBirth'}
                applicationNo={applicationNo}
                imageType={'photoBirth'}
                id="photoBirth"
                file={formik.values && formik.values.photoBirth}
                fileName={formik.values && formik.values.photoBirthFileName}
                imagePreviewUrl={
                  formik.values && formik.values.photoBirthImagePreviewUrl
                }
                handleUpdateFileInfo={(file, fileName, imagePreviewUrl) => {
                  console.log('hi test');
                  handleUpdatePhotoBirthFileInfo(
                    file,
                    fileName,
                    imagePreviewUrl,
                  );
                }}
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Upload Father's Aadhar Card/Passport*
            </Typography>

            <div id="photoFatherAadhar">
              <FileUploadViewer
                key={`key-photoFatherAadhar`}
                info={'photoFatherAadhar'}
                id="photoFatherAadhar"
                applicationNo={applicationNo}
                imageType={'photoFatherAadhar'}
                file={formik.values && formik.values.photoFatherAadhar}
                fileName={
                  formik.values && formik.values.photoFatherAadharFileName
                }
                imagePreviewUrl={
                  formik.values &&
                  formik.values.photoFatherAadharImagePreviewUrl
                }
                handleUpdateFileInfo={(file, fileName, imagePreviewUrl) => {
                  console.log('hi test');
                  handleUpdateFatherAadharFileInfo(
                    file,
                    fileName,
                    imagePreviewUrl,
                  );
                }}
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Upload Mother's Aadhar Card/Passport*
            </Typography>

            <div id="photoMotherAadhar">
              <FileUploadViewer
                key={`key-photoMotherAadhar`}
                info={'photoMotherAadhar'}
                id="photoMotherAadhar"
                file={formik.values && formik.values.photoMotherAadhar}
                fileName={
                  formik.values && formik.values.photoMotherAadharFileName
                }
                imagePreviewUrl={
                  formik.values &&
                  formik.values.photoMotherAadharImagePreviewUrl
                }
                handleUpdateFileInfo={(file, fileName, imagePreviewUrl) => {
                  console.log('hi test');
                   handleUpdateMotherAadharFileInfo(
                    file,
                    fileName,
                    imagePreviewUrl,
                  );
                }}
              />
            </div>
          </Grid>
        </Grid>
        <br />
        <br />
        <Typography
          variant={'subtitle2'}
          sx={{ marginBottom: 2 }}
          fontWeight={700}
        >
          NOTE: Allowed jpeg, jpg and pdf only up to 1MB. Special characters are
          not allowed in file name.
        </Typography>

        <br />

       
          
    {sectionData === '11' && (  

        <Box
          marginBottom={{ xs: 0, sm: 4 }}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
        >
          <Typography
            variant="h4"
            gutterBottom
            align={'center'}
            sx={{
              fontWeight: 900,
            }}
          >
            Details Of Schooling
          </Typography>
        </Box>
       )}

       {sectionData === '11' && (  
        <div
          style={{
            width: '100%',
            textAlign: 'right',
            marginTop: '10px',
            padding: '10px',
          }}
        >
          {' '}
          <Button onClick={HandleAddSchoolInfo}>Add</Button>
        </div>
        )}

          


        {noOfYears.map((rec, index) => (
       sectionData == '11' && (  
          <YearInformation
            key={`class-${index}`}
            rec={rec}
            handleRemove={handleRemove}
          />
       )
        
        ))}


  
    
   

        <Box
          component={Button}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          height={54}
          //   href='/not-found-cover'
          marginTop={{ xs: 8, sm: 9 }}
          marginLeft={{ sm: 40 }}
        >
          <span onClick={() => handleCurrentStep(2)}>Go Back</span>
        </Box>

        <Box
          component={Button}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          height={54}
          marginTop={{ xs: 8, sm: 9 }}
          marginLeft={{ sm: 4 }}
          disabled={isDisabled}
          readOnly={isDisabled}
          onClick={onSubmit}
          // href = '/startup'
        >
          Save and Continue
        </Box>
      </div>
    </Box>
  );
};

export default ThirdStep;
